@if (agreementTextIsOpened) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60">
    <div class="h-full w-full">
      <div class="agreementTextDialog">
        <div class="flex flex-col h-full w-full p-5 overflow-y-hidden">
          <div class="flex-none">
            <div class="flex flex-row justify-between pb-1">
              <p class="text-center font-semibold text-xl">{{agreementTitleDialog}}</p>
              <div>
                <button class="hover:bg-gray-100 rounded-full p-0.5 w-8 h-8" (click)="downloadTextAgreement()" aria-label="Download Agreement">
                  <fa-icon [icon]="faDownload"></fa-icon>
                </button>
                <button class="hover:bg-gray-100 rounded-full p-0.5 w-8 h-8" (click)="closeAgreementTextDialog()" aria-label="Close Agreement">
                  <fa-icon [icon]="faXmark"></fa-icon>
                </button>
              </div>
            </div>
            <hr />
          </div>
          <div class="flex-1 overflow-y-auto mt-1">
            @if (checkForHTMLTags(agreementTextDialogString)) {
              <div [innerHTML]="agreementTextDialogString"></div>
            }
            @if (!checkForHTMLTags(agreementTextDialogString)) {
              <div [innerText]="agreementTextDialogString"></div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (openAddAssignTimeDialog) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full">
      <div class="absolute flex flex-col shadow rounded-[16px] bg-white h-fit w-[450px] m-auto bottom-[35%] left-0 right-0 p-5 text-left">
        <p class="font-bold z-10 mt-3">Create new ADA Accommodation</p>
        <p class="mt-3 z-10 text-sm font-medium">ADA Accommodation Title: <span class="text-red-600">*</span></p>
        <input type="text" class="mt-1 input" placeholder="Enter title" [(ngModel)]="adaTitle">
        @if (adaTitleValidation) {
          <p class="text-sm text-red-500 font-semibold">Title is required</p>
        }
        <p class="mt-3 z-10 text-sm font-medium">Add Time Multiplier:</p>
        <input type="number" min="1" class="mt-1 input" placeholder="Enter time multiplier" [(ngModel)]="adaTimeMultipler">
        <p class="mt-3 z-10 text-sm font-medium">or Add Time Addition:</p>
        <input type="number" min="0" class="mt-1 input" placeholder="Enter time addition" [(ngModel)]="adaTimeAddition">
        @if (adaTimeAddValidation && adaTimeMultValidation) {
          <p class="text-sm text-red-500 font-semibold">Multiplier or Additional time is required</p>
        }
        <p class="mt-3 z-10 text-sm font-medium">Add Organization:<span class="text-red-600">*</span></p>
        <dropdown-search [items]="orgList" [addedList]="addedOrgList" placeholder="Search for organization" [singleItemList]="true" class="mt-1" />
        @if (adaCourseValidation) {
          <p class="text-sm text-red-500 font-semibold">Org is required</p>
        }
        <div class="flex">
          @for (addedOrg of addedOrgList; track addedOrg) {
            <chip (click)="addedOrgList = removeItemFromList(addedOrg, addedOrgList)" [text]="addedOrg.name ? addedOrg.name : ''"/>
          }
        </div>
        @if (adaResponseMsg !== '') {
          <p class="text-sm text-red-500 font-semibold">{{adaResponseMsg}}</p>
        }
        <div class="flex justify-end mt-4">
          <outline-button [marginRight]="true" (click)="cancelAssignDialog()" text="Cancel" />
          <full-button (click)="saveTimeClick()" text="Save" />
        </div>
      </div>
    </div>
  </div>
}
@if (openProfileImageChange) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full">
      <div class="absolute flex flex-col shadow rounded-[16px] bg-white h-fit w-[450px] h-[450px] m-auto bottom-0 top-0 left-0 right-0 p-5 text-center">
        <p class="font-bold z-10 mt-3">Select Profile Picture</p>
        <div class="overflow-y-auto h-[450px]">
          @for (image of listOfProfileImages; track image; let i = $index) {
            <button aria-label="Select New Profile Image" (click)="selectProfileImage(i)" [ngClass]="changedProfileImage === i? 'm-1 inline-block hover:bg-gray-600 bg-gray-400 rounded-[8px]': 'm-1 inline-block hover:bg-gray-200 z-10 rounded-[8px]'">
              <img alt="Profile Image" [ngSrc]="image" height="100" width="100">
            </button>
          }
        </div>
        <div class="flex justify-right mt-5">
          <clear-button (click)="openProfileImageChange = false" text="Cancel" />
        </div>
      </div>
    </div>
  </div>
}
@if (openDeleteTimeDialog) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full">
      <div class="absolute flex flex-col shadow rounded-[16px] overflow-hidden bg-white h-fit w-[450px] m-auto bottom-[45%] left-0 right-0 p-5 text-center">
        <p class="font-bold z-10 mt-3">Sure you want to delete the ADA time for {{deleteCourseName}}?</p>
        <p class="z-10 mt-1 text-sm">Are you sure you want to delete this ADA time?</p>
        <p class="z-10 text-sm"> This action can <b>NOT</b> be reversed.</p>
        <fa-icon [icon]="faTrash" class="text-4xl mt-2"/>
        <div class="flex justify-evenly mt-5">
          <full-button (click)="confirmDeleteTimeClick()" text="Delete" />
          <outline-button (click)="closeDeleteTimeClick()" text="Cancel" />
        </div>
        <fa-icon class="backgroundDelete" [icon]="faTrash" size="10x"></fa-icon>
      </div>
    </div>
  </div>
}
@if (saveChangesDialog) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60">
    <div class="h-full w-full">
      <div class="saveDialog">
        <p class="font-semibold text-xl">
          Profile Saved!
        </p>
        <img alt="Saved Image" src="assets/images/profileSavedFloppy.PNG" class="mt-3 h-[120px] w-[120px]" />
      </div>
    </div>
  </div>
}
@if (openAddRoleDialog || confirmDeleteRole) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full">
      <div class="absolute flex flex-col shadow rounded-[16px] bg-white h-fit w-[450px] m-auto bottom-0 top-0 left-0 right-0 p-5 text-left">
        @if (openAddRoleDialog) {
          <div>
            <p class="font-bold z-10 my-3">Add new role</p>
            <dropdown-search [getRoleDetails]="true" [items]="userRoles" [addedList]="addedTempUserRole" [singleItemList]="true" placeholder="Search for roles" class="mt-2"/>
            @if (addedTempUserRole.length > 0) {
              <div>
                @if (addedTempUserRole[0].subjects != null && addedTempUserRole[0].subjects.length !== 0 || addedTempUserRole[0].units != null && addedTempUserRole[0].units.length !== 0) {
                  <p class="text-sm mt-2">
                    Add <b>only one</b> of the four contexts from below. The contexts work top down, meaning if you assign a role at the organization level they will also have that role for each context (the subjects, units, and courses) that reside underneath it.
                    <br/><br/>
                    The contexts reside underneath each other in this order. organization > subject > unit > course.
                  </p>
                }
                @if (addedTempUserRole[0].organizations != null && addedTempUserRole[0].organizations.length !== 0) {
                  <div>
                    <p class="mt-3 text-sm">Organizations</p>
                    <dropdown-search
                      [disabled]="addedCourseList.length > 0 || addedSubjectList.length > 0 || addedUnitList.length > 0"
                      [items]="addedTempUserRole[0].organizations"
                      [addedList]="addedOrgList"
                      [singleItemList]="true"
                      placeholder="Choose organization"
                      [isOrganization]="true"
                      />
                    </div>
                  }
                  @for (org of addedOrgList; track org; let i = $index) {
                    <chip [text]="org.organization_name != undefined? org.organization_name:''" (click)="addedOrgList.splice(i, 1)" />
                  }
                  @if (addedTempUserRole[0].subjects != null && addedTempUserRole[0].subjects.length !== 0) {
                    <div>
                      <p class="mt-3 text-sm">Subjects</p>
                      <dropdown-search
                        [disabled]="addedOrgList.length > 0 || addedCourseList.length > 0 || addedUnitList.length > 0"
                        [items]="addedTempUserRole[0].subjects"
                        [addedList]="addedSubjectList"
                        [singleItemList]="true"
                        placeholder="Choose subjects"
                        [isSubject]="true"
                        />
                      </div>
                    }
                    @for (subject of addedSubjectList; track subject; let i = $index) {
                      <chip [text]="subject.subject_name != undefined? subject.subject_name:''" (click)="addedSubjectList.splice(i, 1)" />
                    }
                    @if (addedTempUserRole[0].units != null && addedTempUserRole[0].units.length !== 0) {
                      <div>
                        <p class="mt-3 text-sm">Units</p>
                        <dropdown-search
                          [disabled]="addedOrgList.length > 0 || addedCourseList.length > 0 || addedSubjectList.length > 0"
                          [items]="addedTempUserRole[0].units"
                          [addedList]="addedUnitList"
                          [singleItemList]="true"
                          placeholder="Choose units"
                          [isUnit]="true"
                          />
                        </div>
                      }
                      @for (unit of addedUnitList; track unit; let i = $index) {
                        <chip [text]="unit.unit_name != undefined? unit.unit_name:''" (click)="addedUnitList.splice(i, 1)" />
                      }
                      @if (addedTempUserRole[0].courses != null && addedTempUserRole[0].courses.length !== 0) {
                        <div>
                          <p class="mt-3 text-sm">Courses</p>
                          <dropdown-search
                            [disabled]="addedOrgList.length > 0 || addedUnitList.length > 0 || addedSubjectList.length > 0"
                            [items]="addedTempUserRole[0].courses"
                            [addedList]="addedCourseList"
                            [singleItemList]="true"
                            placeholder="Choose course"
                            [isCourse]="true"
                            />
                          </div>
                        }
                        @for (course of addedCourseList; track course; let i = $index) {
                          <chip [text]="course.course_name != undefined? course.course_name:''" (click)="addedCourseList.splice(i, 1)" />
                        }
                      </div>
                    }
                    <div class="flex justify-end mt-3">
                      <outline-button [marginRight]="true" (click)="openAddRoleDialog = false" text="Cancel" />
                      <full-button (click)="addRole(addedTempUserRole[0].role_id, addedOrgList[0].organization_id, addedSubjectList[0].subject_id, addedUnitList[0].unit_id, addedCourseList[0].course_id)" text="Add Role" />
                    </div>
                  </div>
                }
                @if (confirmDeleteRole) {
                  <div>
                    <p class="font-bold z-10 my-3">Remove {{roleToDelete?.role_name}} role from {{user?.display_name}}?</p>
                    <div class="flex justify-end items-center mt-3">
                      <outline-button text="Cancel" (click)="cancelDeleteRole()" [marginRight]="true" />
                      <full-button text="Confirm" (click)="confirmRemoveRole(roleToDelete)" />
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
        <div class="m-5 overflow-y-auto pb-5">
          <div>
            <div class="flex flex-row justify-between mb-1">
              <p class="font-medium text-2xl">
                Profile
              </p>
              @if (!editFormIsOpened) {
                <clear-button (click)="openEditProfile()" [faIcon]="faPenToSquare" text="Edit" />
              }
              @if (editFormIsOpened) {
                <div>
                  <outline-button [marginRight]="true" text="Cancel" [faIcon]="faXmark" (click)="closeEditProfile()" />
                  <full-button (click)="saveEditProfile()" [faIcon]="faCheck" text="Save" />
                </div>
              }
            </div>
            <hr />
          </div>
          @if (user) {
            <div class="flex flex-row my-10">
              <div class="flex flex-col justify-start items-center mr-12">
                @if (selectedProfileImage == null) {
                  <div class="bg-gray-200 text-gray-400 font-bold h-[154px] w-[154px] rounded-full flex items-center justify-center text-6xl">
                    {{user.given_name[0]}} {{user.family_name[0]}}
                  </div>
                }
                @if (selectedProfileImage != null && !editFormIsOpened) {
                  <img alt="Profile Image" [ngSrc]="listOfProfileImages[selectedProfileImage]" height="154" width="154" class="rounded-full" />
                }
                @if (changedProfileImage != null && editFormIsOpened) {
                  <img alt="Profile Image" [ngSrc]="listOfProfileImages[changedProfileImage]" height="154" width="154" class="rounded-full" />
                }
                <!-- ngIf person can edit the profile then have a button here on the profile image circle -->
                @if (editFormIsOpened) {
                  <clear-button (click)="openProfileImageChange = true" class="mt-1" text="Edit Profile Picture" />
                }
              </div>
              @if (!editFormIsOpened) {
                <div>
                  <div class="flex flex-row items-baseline">
                    <p class="text-xl font-semibold">{{user.display_name}}</p>
                    <p class="text-sm text-[#5D6974] ml-3">({{user.pronouns}})</p>
                  </div>
                  <p class="mb-6">{{user.description? user.description: ''}}</p>
                  <div class="flex">
                    <p><b>Role: </b></p>
                    @if (user.roles.length === 0) {
                      <p class="ml-1">user has no roles</p>
                    }
                    @for (role of user.roles | slice: 0: 3; track role; let i = $index) {
                      <p class="ml-1">
                        {{role.role_name}}{{i < 2? ", ": ""}}
                      </p>
                    }
                    @if (user.roles.length > 3) {
                      <p>... and {{user.roles.length - 3}} more role(s)</p>
                    }
                  </div>
                  <p><b>NetID:</b> {{user.username}}</p>
                  <p><b>Email:</b> {{user.email}}</p>
                  @if (user.email_alts[0] !== undefined) {
                    <p><b>Secondary Email:</b> {{user.email_alts[0]}}</p>
                  }
                </div>
              }
              @if (editFormIsOpened) {
                <div>
                  <div class="grid grid-cols-4 w-full lg:w-[550px]">
                    <p class="flex flex-row items-center">Name</p>
                    <input type="text" id="name" class="col-span-3" value='{{user.display_name}}' aria-label="Display Name"/>
                    <div class="col-span-4 text-[#8B96A2] text-[12px] my-2">
                      This is the display name. Changing this will not change your official name in the system. Contact admin for official name change.
                    </div>
                    <p class="flex flex-row items-center">Pronouns</p>
                    <input type="text" id="pronouns" class="col-span-3" value='{{user.pronouns? user.pronouns: ""}}' aria-label="Pronouns"/>
                    <div class="col-span-4 text-[#8B96A2] text-[12px] my-2">
                      You can change your pronouns here to better reflect your gender identity.
                    </div>
                    <p class="flex flex-row items-center">Department</p>
                    <!-- TODO need to check user role -->
                    <input type="text" id="department" class="col-span-3" value='{{user.description}}' aria-label="Department Description"/>
                    <div class="col-span-4 text-[#8B96A2] text-[12px] my-2">
                      Change the department here to give a better description of your position at the university if applicable.
                    </div>
                    <p class="flex flex-row items-center">Email</p>
                    <input type="text" id="email" class="col-span-3" value='{{user.email}}' disabled="true" aria-label="Primary Email"/>
                    <div class="col-span-4 text-[#8B96A2] text-[12px] my-2">
                      This is your primary email address. You cannot change this, please contact your admin if you require it changed.
                    </div>
                    <p class="flex flex-row items-center">Secondary Email</p>
                    <input type="email" id="secondaryEmail" class="col-span-3" name="secondaryEmail" value='{{user.email_alts[0]? user.email_alts[0]: ""}}' aria-label="Secondary Label"/>
                    <div class="col-span-4 text-[#8B96A2] text-[12px] my-2">
                      @if (secondaryEmailValidation) {
                        <p class="text-red-500 font-semibold">Secondary email is in an invalid format</p>
                      }
                      This is your secondary email address. You are allowed to change this email so as to have an alternate email address.
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          @if (user === null && !editFormIsOpened) {
            <div class="flex flex-row my-10">
              <div class="bg-gray-100 w-[154px] h-[154px] rounded-full mr-12 animate-pulse">
                <!-- TODO add profile image -->
              </div>
              <div>
                <div class="animate-pulse bg-gray-100 mb-1 h-[28px] w-[200px]"></div>
                <div class="animate-pulse bg-gray-100 mb-6 h-[24px] w-[300px]"></div>
                <div class="animate-pulse bg-gray-100 mb-1 h-[24px] w-[200px]"></div>
                <div class="animate-pulse bg-gray-100 mb-1 h-[24px] w-[200px]"></div>
                <div class="animate-pulse bg-gray-100 mb-1 h-[24px] w-[200px]"></div>
              </div>
            </div>
          }
          @if (!editFormIsOpened) {
            <div class="mt-14">
              <div class="flex justify-between items-center">
                <p><b>Roles</b></p>
                @if (roleManager) {
                  <clear-button (click)="openAddRoleDialog = true" text="Add Role" [faIcon]="faAdd"/>
                }
              </div>
              <div>
                <div class="grid grid-cols-5 mt-3">
                  <div class="col-span-2">
                    Role Name
                  </div>
                  <div>
                    Subject Name
                  </div>
                  <div>
                    Unit Name
                  </div>
                  <div>
                    Date Added
                  </div>
                  <hr class="col-span-5 mt-1"/>
                </div>
                @for (role of addedUserRoles | slice: 0: showMoreRoles? addedUserRoles.length : 3; track role; let i = $index) {
                  <div class="grid grid-cols-5">
                    <div class="col-span-2 mt-1">
                      {{role.role_name}}
                    </div>
                    <div>
                      @if (role.subjects != null && role.subjects.length > 0 && role.subjects[0].name != null) {
                        <div>
                          {{role.subjects[0].name}}
                        </div>
                      }
                    </div>
                    <div>
                      @if (role.units != null && role.units.length > 0 && role.units[0].name != null) {
                        <div>
                          {{role.units[0].name}}
                        </div>
                      }
                    </div>
                    <div class="flex justify-between items-center">
                      @if (role.date != null) {
                        <div>
                          {{role.date | date: 'MM/dd/y'}}
                        </div>
                      }
                      @if (roleManager) {
                        <button (click)="openConfirmDeleteRole(role)" class="text-slate-500 text-xs" aria-label="Delete Role">
                          <fa-icon [icon]="faTrash" />
                        </button>
                      }
                    </div>
                  </div>
                }
                @if (addedUserRoles.length > 3) {
                  <clear-button (click)="showMoreRoles = !showMoreRoles" text="{{showMoreRoles? 'view less':'view all'}}" />
                }
              </div>
            </div>
          }
          @if (userAgreements.length !== 0 && !editFormIsOpened) {
            <div class="mt-14">
              <div>
                <p><b>User Agreements Accepted</b></p>
              </div>
              <div>
                <div class="grid grid-cols-8 mt-3">
                  <div class="col-span-7">
                    Title
                  </div>
                  <div>
                    Date
                  </div>
                  <!--
                  <div>
                    Status
                  </div>
                  -->
                  <hr class="col-span-8 mt-1" />
                </div>
                @for (agreement of userAgreements | slice:0:showMoreAgreements? userAgreements.length : 3; track agreement; let i = $index) {
                  <div class="grid grid-cols-8 mt-2">
                    <div class="col-span-7">
                      <!-- TODO make clickable and create popup for agreement text -->
                      <button class="underline text-start" (click)="openAgreementText(i)">
                        {{agreement.name}}
                      </button>
                    </div>
                    <div>
                      {{agreement.response_date}}
                    </div>
                    <!--
                    <div *ngIf="agreement.retire_date != null && currentDate != null">
                      {{agreement.retire_date > currentDate ? 'Inactive' : 'Active'}}
                    </div>
                    -->
                  </div>
                }
                @if (userAgreements.length > 3) {
                  <clear-button (click)="showMoreAgreements = !showMoreAgreements" text="{{showMoreAgreements? 'view less':'view all'}}" />
                }
              </div>
            </div>
          }
          @if (!editFormIsOpened) {
            <div class="mt-14">
              <div class="mt-3 flex justify-between">
                @if (accommodationManager || extraTime.length !== 0) {
                  <p><b>ADA Accommodation</b></p>
                }
                @if (accommodationManager) {
                  <clear-button (click)="openAddTime()" [faIcon]="faPlus" text="Add Accommodation" />
                }
              </div>
              @if (user != null && user.extra_time.length !== 0) {
                <div class="grid grid-cols-10 mt-3 px-3 p-2">
                  <div></div>
                  <div class="col-span-6">
                    Title
                  </div>
                  <div>
                    Course
                  </div>
                  <div>
                    Date
                  </div>
                  <div>
                    Additional time
                  </div>
                  <hr class="col-span-10 mt-1" />
                </div>
              }
              @for (time of extraTime | slice: 0: showMoreTime? extraTime.length : 3; track time) {
                <div>
                  @if (!time.expanded) {
                    <div class="grid grid-cols-10 mt-2 px-3 p-2">
                      <div class="flex justify-center">
                        @if (accommodationManager) {
                          <button (click)="time.expanded = !time.expanded" class="border border-[#c0c7ce] rounded w-fit h-fit hover:bg-gray-200 mr-0 px-1">
                            <fa-icon [icon]="faChevronDown" />
                          </button>
                        }
                      </div>
                      <div class="col-span-6">
                        {{time.title}}
                      </div>
                      <div>
                        {{time.course_name}}
                      </div>
                      <div>
                        {{time.date | date:'MM/dd/y'}}
                      </div>
                      <div>
                        {{time.time_multiplier !== 0 && time.time_addition === 0? time.time_multiplier + "x":""}}
                        {{time.time_multiplier === 0 && time.time_addition !== 0? time.time_addition + " minute(s)":""}}
                        {{time.time_multiplier !== 0 && time.time_addition !== 0? time.time_multiplier + "x and " + time.time_addition + " minute(s)":""}}
                      </div>
                    </div>
                  }
                  @if (time.expanded) {
                    <div class="grid grid-cols-10 mt-2 grid-rows-2 rounded-lg bg-[#F6F7F8] px-3 p-2">
                      <div class="flex justify-center">
                        <button (click)="time.expanded = !time.expanded" class="border border-[#c0c7ce] rounded w-fit h-fit hover:bg-gray-200 mr-0 px-1">
                          <fa-icon [icon]="faChevronUp" />
                        </button>
                      </div>
                      <div class="col-span-6">
                        {{time.title}}
                      </div>
                      <div>
                        {{time.course_name}}
                      </div>
                      <div>
                        {{time.date | date:'MM/dd/y'}}
                      </div>
                      <div>
                        {{time.time_multiplier !== 0 && time.time_addition === 0? time.time_multiplier + "x":""}}
                        {{time.time_multiplier === 0 && time.time_addition !== 0? time.time_addition + " minute(s)":""}}
                        {{time.time_multiplier !== 0 && time.time_addition !== 0? time.time_multiplier + "x and " + time.time_addition + " minute(s)":""}}
                      </div>
                      <div class="col-span-10 flex justify-end">
                        <outline-button (click)="openDeleteTimeClick(time.course_id, time.course_name)" [faIcon]="faTrash" text="Delete Accommodation" />
                      </div>
                    </div>
                  }
                </div>
              }
              @if (extraTime.length > 3) {
                <clear-button (click)="showMoreTime = !showMoreTime" text="{{showMoreTime? 'view less':'view all'}}" />
              }
            </div>
          }
        </div>
